var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-wrench"}),_vm._v("\n\t\t\tServices Apps\n\t\t")]),_c('projects-toolbar-controls',{attrs:{"is-services":true,"mobile-breakpoint":_vm.mobileBreakpoint}})],1),_c('addon-app-tab',{attrs:{"ui-location":"Services Module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }